import * as Sentry from '@sentry/react'
import { AlertTriangle } from 'lucide-react'
import { useEffect } from 'react'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom'
import { Button } from '@/components/ui/Button'

export function RouteErrorBoundary() {
  const error = useRouteError()

  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unexpected route error'

  return (
    <div className="grid min-h-[70vh] place-items-center p-6">
      <section className="w-full max-w-lg rounded-2xl border border-status-failed/20 bg-raised p-8 text-center shadow-2xl">
        <span className="mx-auto grid size-12 place-items-center rounded-xl bg-status-failed-solid text-status-failed">
          <AlertTriangle size={22} aria-hidden="true" />
        </span>
        <p className="mt-5 text-xs font-bold tracking-[0.14em] text-status-failed uppercase">
          Route error
        </p>
        <h1 className="mt-2 text-2xl font-semibold text-primary">
          Unable to display this page
        </h1>
        <p className="mt-3 text-sm leading-6 text-muted">{message}</p>
        <Button asChild className="mt-6">
          <Link to="/dashboard">Return to dashboard</Link>
        </Button>
      </section>
    </div>
  )
}
